import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SELECT_INPUT_CARET_URL } from '../constants';

function Radius() {
  const dispatch = useDispatch();
  // note that the default searchRadius is set in index.jsx
  const { selectedRadius } = useSelector(store => store.doctors);
  const options = [
    { val: 3, desc: '3 miles' },
    { val: 5, desc: '5 miles' },
    { val: 10, desc: '10 miles' },
    { val: 15, desc: '15 miles' },
    { val: 20, desc: '20 miles' },
    { val: 30, desc: '30 miles' },
    { val: 40, desc: '40 miles' },
    { val: 50, desc: '50 miles' },
    { val: 75, desc: '75 miles' },
    { val: 100, desc: '100 miles' },
  ];

  function handleChange(event) {
    const val = Number(event.target.value);
    dispatch({ type: 'SET_DOCTORS_RADIUS', payload: val });
  }

  return (
    <>
      Within
      <select
        style={{
          backgroundImage: SELECT_INPUT_CARET_URL,
          paddingRight: '2rem',
        }}
        id="doctor-select-radius-input"
        className="form-select me-3"
        onChange={handleChange}
        value={selectedRadius}
      >
        {options.map((o) => (
          <option key={o.val} value={o.val}>{o.desc}</option>
        ))}
      </select>
    </>
  );
}

export default Radius;
